// extracted by mini-css-extract-plugin
export default {"confirmBtn":"styles_confirmBtn__BctzL","cancelBtn":"styles_cancelBtn__X1B-0","modalBtn":"styles_modalBtn__Tc3-T"};